/** The account band (plan "Page anatomy" → Account band): the record fact band
 *  (`records/band/FactBand`) over the person's cells. Each cell leads to what owns its
 *  facts: a tab (a real link), or the Trips panel. */
import { FactBand, type FactBandTarget } from '@/features/records/band/FactBand';

import type { BandCell, BandTab } from './accountBandModel';

export interface AccountBandProps {
  cells: BandCell[];
  /** The tabs the viewer sees: a cell links only to one of them. */
  tabs: ReadonlySet<string>;
  hrefFor: (tab: BandTab) => string;
  /** What the Trips cell does (focus the Trips panel). */
  onTrips?: () => void;
}

export function AccountBand({ cells, tabs, hrefFor, onTrips }: AccountBandProps) {
  const targetOf = (c: BandCell): FactBandTarget => {
    if (c.id === 'trips' && onTrips) return { onClick: onTrips };
    if (c.tab && tabs.has(c.tab)) return { to: hrefFor(c.tab) };
    return null;
  };
  return <FactBand label="Account summary" name="account" cells={cells} targetOf={targetOf} />;
}
